import { Components, Theme } from '@mui/material';

export const getMuiListItemText = (
  theme: Theme,
): Components['MuiListItemText'] => ({
  styleOverrides: {
    root: {
      '&[data-variant="watchduty-legend"]': {
        '& .MuiListItemText-primary': {
          ...theme.typography.body1,
          fontWeight: theme.typography.fontWeightBold,
        },
        '& .MuiListItemText-secondary': {
          ...theme.typography.body2,
          // Resolve at runtime so dark mode gets the correct secondary ink (see MuiTab).
          color: 'var(--mui-palette-text-secondary)',
        },
      },
    },
  },
});
